import { LandingData } from "@/types/types";
import styled from "styled-components";
import { MaxWidthContainer as ParentMaxWidthContainer } from "../styles";
import { H2 } from "@/components/ui/typography";
import { Colors } from "@/theme";
import { mobile } from "@/theme/common";
import { Item } from "../Item";
import { ButtonRegular } from "@/components/ui/buttons";

export const HOW_TO_PLAY_SECTION_ID = "how-to-play";

/**
 * Types
 */

interface HowToPlayData {
  data: LandingData["sections"]["howToPlay"];
  handleRedirectToGame: () => void;
  acquisition?: LandingData["acquisition"];
}

/**
 * Styled Components
 */

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  background-color: ${Colors.gray100};
  width: 100%;
  padding: 48px 0;
  ${mobile(`
    padding: 40px 16px;
  `)}
`;

const MaxWidthContainer = styled(ParentMaxWidthContainer)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 24px;
`;

const Title = styled(H2)`
  text-align: center;
`;

const ItemsContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 16px;
`;

const Button = styled(ButtonRegular)`
  border-radius: 12px;
  background-color: ${Colors.yellow500};
  color: ${Colors.black};
`;

/**
 * HowToPlaySection Component
 */

export const HowToPlaySection = ({
  data,
  handleRedirectToGame,
  acquisition,
}: HowToPlayData) => {
  if (!data) {
    return null;
  }

  const { title, steps, buttonText } = data;
  return (
    <Container id={HOW_TO_PLAY_SECTION_ID}>
      <MaxWidthContainer>
        <Title
          dangerouslySetInnerHTML={{
            __html: title,
          }}
        />
        <ItemsContainer>
          {steps.map((step) => (
            <Item
              key={step.title}
              title={step.title}
              description={step.description}
              icon={step.icon ?? ""}
            />
          ))}
        </ItemsContainer>
        {!acquisition && (
          <Button
            text={buttonText}
            onClick={handleRedirectToGame}
            thickBorder="rgba(0, 0, 0, 0.2)"
          />
        )}
      </MaxWidthContainer>
    </Container>
  );
};
